import React from "react";
import "./Detail.less";
import TankComponent from "../../common/component/TankComponent";
import { Button, Tag, Space } from "antd";
import InfoCell from "../widget/InfoCell";
import User from "../../common/model/user/User";
import Moon from "../../common/model/global/Moon";
import DateUtil from "../../common/util/DateUtil";
import TankTitle from "../widget/TankTitle";
import TankContentCard from "../widget/TankContentCard";
import { Link, RouteComponentProps } from "react-router-dom";
import ImagePreviewer from "../widget/previewer/ImagePreviewer";
import { UserRole, UserRoleMap, UserPhoneMap } from "../../common/model/user/UserRole";
import FileUtil from "../../common/util/FileUtil";
import { UserStatus, UserStatusMap } from "../../common/model/user/UserStatus";
import BrowserUtil from "../../common/util/BrowserUtil";
import SingleTextModal from "../widget/SingleTextModal";
import MessageBoxUtil from "../../common/util/MessageBoxUtil";
import ChangePasswordModal from "./widget/ChangePasswordModal";

import {
  EditOutlined,
  UnlockOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import TransfigurationModal from "./widget/TransfigurationModal";
import { FileSyncOutlined, StopOutlined } from "@ant-design/icons/lib";
import Lang from "../../common/model/global/Lang";
import Sun from "../../common/model/global/Sun";

interface RouteParam {
  uuid: string;
}

interface IProps extends RouteComponentProps<RouteParam> {}

interface IState {}

export default class Expansion extends TankComponent<IProps, IState> {
  //登录的那个用户
  user: User = Moon.getSingleton().user;

  //当前页面正在编辑的用户
  currentUser: User = new User(this);

  //sync loading.
  syncLoading: boolean = false;

  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    let that = this;
    let match = this.props.match;
    this.currentUser.uuid = match.params.uuid;
    this.currentUser.httpDetail();
  }



  render() {
    const user: User = this.user;
    const currentUser: User = this.currentUser;

    const handles = (
      <Space className={`handles ${Sun.getSingleton().isMobile ? 'handles-mobile': ''}`}>

      </Space>
    );

    return (
      <div className="page-expansion-detail">
        <TankTitle name={Lang.t("layout.expansion")}>
          {!Sun.getSingleton().isMobile && handles}
        </TankTitle>
        {Sun.getSingleton().isMobile && handles}

        <TankContentCard loading={currentUser.detailLoading}>
          <div className="text-center mv20">
            <img
              className="avatar-large"
              alt="avatar"
              src={currentUser.getAvatarUrl()}
              onClick={() => {
                ImagePreviewer.showSinglePhoto(currentUser.getAvatarUrl(true));
              }}
            />
            <div className="f24">{currentUser.username}</div>
          </div>

          <InfoCell name={Lang.t("user.role")}>
            喜喜喜喜喜喜喜喜喜喜
          </InfoCell>


          <InfoCell name={Lang.t("user.singleFileSizeLimit")}>
            {FileUtil.humanFileSize(currentUser.sizeLimit)}
          </InfoCell>

          <InfoCell name={Lang.t("user.totalFileSizeLimit")}>
            {FileUtil.humanFileSize(currentUser.totalSizeLimit)}
          </InfoCell>

          <InfoCell name={Lang.t("user.totalFileSize")}>
            {FileUtil.humanFileSize(currentUser.totalSize)}
          </InfoCell>

          <InfoCell name={Lang.t("user.status")}>
            <Tag color={UserStatusMap[currentUser.status].color}>
              {UserStatusMap[currentUser.status].name}
            </Tag>
          </InfoCell>

          <InfoCell name={Lang.t("user.lastLoginIp")}>
            {currentUser.lastIp}
          </InfoCell>

          <InfoCell name={Lang.t("user.lastLoginTime")}>
            {DateUtil.simpleDateTime(currentUser.lastTime)}
          </InfoCell>

          <InfoCell name={Lang.t("user.webdavLink")}>
            {BrowserUtil.fullHost() + "/api/dav"}
          </InfoCell>

        </TankContentCard>
      </div>
    );
  }
}
